import { render, staticRenderFns } from "./summary.pug?vue&type=template&id=74c50d44&lang=pug&external"
import script from "./summary.js?vue&type=script&lang=js&external"
export * from "./summary.js?vue&type=script&lang=js&external"
import style0 from "./summary.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c50d44')) {
      api.createRecord('74c50d44', component.options)
    } else {
      api.reload('74c50d44', component.options)
    }
    module.hot.accept("./summary.pug?vue&type=template&id=74c50d44&lang=pug&external", function () {
      api.rerender('74c50d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/summary/index.vue"
export default component.exports